import axios from 'axios';

export type Subdomain = {
  id: string;
  key: string;
  deactivatedDiscovery: boolean;
  deactivatedValidation: boolean;
}

export type User = {
  id: number;
  displayName?: string;
  email: string;
  avatarUrl?: string;
  jobTitle?: string;
  coreAdmin: boolean;
  coreOwner: boolean;
  coreAllowsSettings: boolean;
  uvkAdmin: boolean;
  lastLogin?: any;
}

export type Account = {
  coreAccess: boolean;
  uvkAccess: boolean;
  maxFullaccessAdmins: number | null;
  maxHelpdeskAdmins: number | null;
  maxContributors: number | null;
  currentFullaccessAdmins: number;
  currentHelpdeskAdmins: number;
  currentContributors: number;
  deactivatedDiscovery: boolean;
  deactivatedValidation: boolean;
  needsCreditCard: boolean;
  plan?: Plan;
  rate?: number;
  perAdminRate?: number;
  paymentDate?: string;
  billingInterval?: string;
};

export type Plan = {
  name: string;
  rateCents: number;
  rateType: string;
};

export type CurrentAccountResponse = {
  authorizedFeatures: (string | null)[];
  currentSubdomain: Subdomain;
  currentUser?: User;
  currentAccount?: Account;
}

export const getCurrentAccount = async (): Promise<[CurrentAccountResponse, null]> => {
  const { data } = await axios.get<CurrentAccountResponse>('/api/account/current');
  return [data, null];
};
